module.exports = __webpack_public_path__ + "img/ability-6.e487ede6.png";